import $ from 'gridstrap/lib/gs-zepto';

export class GSFormHidden {

	//
	// Properties
	//

	private root;
	private form;
	private setters;

	get name()       { return this.root.prop('name'); }
	set value(value) { this.root.val(value); }

	//
	// Initializations & Event Listeners
	//

	constructor(root) {
		this.root = $(root);
		this.form = this.root.closest('.gs-Form');
		this.setters = this.form.find(`[data-gs-form-set-field="${this.name}"]`);
		this.setters.on('click', evt => this.handleSetterClick(evt));
	}

	private handleSetterClick(evt) {
		let clicked = $(evt.currentTarget);
		let value = clicked.data('gsFormSetValue');
		this.value = value;
	}

}
